module.exports = __webpack_public_path__ + "static/media/TalksPro_Logo.c1a3e957.svg";